var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('l-confirm-dialog',{ref:"exportStarted",attrs:{"title":_vm.$t('exportStarted'),"content":_vm.$t('exportInfo'),"action":_vm.$t('ok'),"cancelable":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }